// SCRUM-448: shared detector for the "reconnect Jira" signal (HTTP 409 +
// reason "reauth_required"). SCRUM-440 raises the same signal for the
// token-can't-access-cloud_id case, so this stays the single source of truth.
export function isJiraReauthError(error) {
  const res = error && error.response;
  return Boolean(res && res.status === 409 && res.data && res.data.reason === 'reauth_required');
}
